import { render } from "./index.vue?vue&type=template&id=49dd0522&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=49dd0522&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/hw-employment-front-end-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49dd0522"]])

export default __exports__